var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-tiles-container"},[_c('h1',[_vm._v(_vm._s(_vm.articlesTitle))]),_vm._v(" "),_c('h2',[_vm._v("\n    "+_vm._s(_vm.articlesDescription)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"child"},[_c('ArticleTiles',{attrs:{"tiles":_vm.tiles},on:{"buttonClicked":_vm.readMore}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }